// extracted by mini-css-extract-plugin
module.exports = {"mappingDropdown":"styles_mappingDropdown__snLiF","dropdownElement":"styles_dropdownElement__V_v8V","newTag":"styles_newTag__5tvOb"};